import { date } from "quasar";
const { isValid } = date;

export const isValidDateString = (dateString, separator = "-") => {
  try {
    const [day, month, year] = dateString?.split(separator) || [];

    if (dateString?.length === 10 && day && month && year) {
      return isValid(new Date(year, month, day));
    }
  } catch (error) {
    console.error(error);
  }
};

export const isValidPhoneNumber = (num) => {
  const regexp = /^\d+$/;

  return regexp.test(num) && String(num).length === 10;
};

export const detectSpace = (value) => {
  const regexp = /\s+/g;

  return regexp.test(value);
};

export const isValidGstin = (value) =>
  /^\d{2}[A-Z]{5}\d{4}[A-Z][0-9A-Z]{3}$/.test(value);

export const isHtmlEmpty = (html) => {
  if (!html) return true;

  const temp = document.createElement("div");

  temp.innerHTML = html;

  const text = (temp.textContent || "").replaceAll("\u00A0", " ").trim();

  return text.length === 0;
};
export default {
  isValidDateString,
  isValidPhoneNumber,
  detectSpace,
  isValidGstin,
  isHtmlEmpty,
};
